import React from "react";
import { MessageSquare } from "lucide-react";
import PageBanner from "./PageBanner";
import Contact from "./Contact";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#fafcff]">
      <PageBanner
        title="Contact Us"
        description="We'd love to hear from you. Reach out to the IEEE ISIMS Student Branch team for inquiries, collaborations, or just to say hello."
        Icon={MessageSquare}
      />
      <Contact />
    </div>
  );
}
